import * as React from "react";
import PropTypes from 'prop-types';

const SvgChallengeCompleted = props => {
  if (props.id !== "_svgchallengecompleted") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 20 20" fill="none" {...props}><circle cx={10} cy={10} r={10} fill="#01803f" /><path d="M8.5 13.5L5 10l1-1 2.5 2.5L14 6l1 1-6.5 6.5z" fill="#fff" /></svg>;
};

SvgChallengeCompleted.displayName = "_svgchallengecompleted";
SvgChallengeCompleted.propTypes = {
  id: PropTypes.string
};
SvgChallengeCompleted.defaultProps = {
  id: ''
};
export default SvgChallengeCompleted;